/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignLeftFilled = createReactComponent("filled", "layout-align-left-filled", "IconLayoutAlignLeftFilled", [["path", { "d": "M4 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M18 8a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

export { IconLayoutAlignLeftFilled as default };
//# sourceMappingURL=IconLayoutAlignLeftFilled.mjs.map
